import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { PendingReferralTask } from '../../pending-referral-tasks.definitions';
import { PendingTaskCardComponent } from './pending-task-card.component';

@Component({
  standalone: true,
  imports: [DatePipe, PendingTaskCardComponent],
  selector: 'lib-pending-referral-task-card',
  host: {
    class: 'block h-full',
  },
  template: `
    <lib-pending-task-card [route]="['/referrals', task().referral.id]">
      <div class="min-w-0">
        <div class="flex flex-wrap items-center gap-1.5">
          <span class="text-sm font-semibold text-gray-900">
            {{ task().referral.referral_code }}
          </span>
          <span
            class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800"
          >
            {{ statusLabel() }}
          </span>
        </div>
        <div class="mt-1 truncate text-sm text-gray-700">
          {{ title() }}
        </div>
        <div class="mt-1 truncate text-xs text-gray-500">
          {{ partyContext() }}
        </div>
      </div>

      <div class="self-end text-xs text-gray-500">
        {{ task().referral.created_at | date : 'dd-MMM-yyyy' }}
      </div>
    </lib-pending-task-card>
  `,
})
export class PendingReferralTaskCardComponent {
  task = input.required<PendingReferralTask>();

  protected readonly statusLabel = computed(() =>
    this.task().kind === 'needs_referee_acceptance'
      ? 'Needs acceptance'
      : 'Waiting on referee'
  );

  protected readonly title = computed(() => {
    const task = this.task();
    const clientName =
      task.referral.external_client_snapshot?.name?.trim() || 'Referral';

    return task.kind === 'needs_referee_acceptance'
      ? `Client: ${clientName} from ${task.referral.referrer_name || '-'}`
      : `Referred to: ${clientName} by ${
          task.referral.referrer_name || '-'
        }`;
  });

  protected readonly partyContext = computed(() => {
    const task = this.task();

    return task.kind === 'needs_referee_acceptance'
      ? `Referrer: ${task.referral.referrer_name || '-'}`
      : `Referee: ${task.referral.referee_name || '-'}`;
  });
}
